import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-4">
              移动入口
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">{appInfo.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">{appInfo.desc}</p>

            <div className="grid grid-cols-2 gap-3 mb-6 max-w-[400px] mx-auto lg:mx-0">
              {appInfo.features.map((f) => (
                <div key={f} className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                  <span className="text-sm text-foreground-700">{f}</span>
                </div>
              ))}
            </div>

            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-bookmark-line"></i>
              收藏本站入口
            </a>
          </div>

          <div className="flex-1 w-full max-w-[360px]">
            <div className="relative w-full aspect-[9/16] max-h-[500px] rounded-2xl overflow-hidden bg-background-100 border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20mobile%20phone%20screen%20mockup%20displaying%20a%20Chinese%20entertainment%20news%20aggregator%20interface%20with%20warm%20orange%20accent%20colors%2C%20clean%20card-based%20layout%20with%20news%20headlines%20and%20topic%20tags%2C%20minimalist%20UI%20design%20with%20soft%20shadows%20and%20ample%20whitespace%2C%20editorial%20news%20app%20aesthetic%20with%20warm%20cream%20background&width=600&height=1067&seq=app-mobile-preview&orientation=portrait"
                alt="黑料吃瓜移动端入口 - 手机浏览界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}